<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/other/util/url"
    let isDelete = {"1":"正常数据","2":"禁用"};
    let codeStatus = {"0":"未使用","1":"已使用","2":"已失效","3":"发送失败"};
    let answerStatus = {"1":"正确","0":"错误"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
      mounted(){
          this.updateData.cols = [
            { title: '主键', field: 'id',hidden:true},
            { title: '文章Id', field: 'articleId',hidden:true,data:this.$route.query.articleId},
            { title: '关联问题内容', field: 'questions',textType:"textarea"},
            { title: '答案一', field: 'answerOne'},
            { title: '是否正确', field: 'answerOneResult',type:3,optionList:answerStatus,isNumber:true,data:0},
            { title: '答案二', field: 'answerTwo'},
            { title: '是否正确', field: 'answerTwoResult',type:3,optionList:answerStatus,isNumber:true,data:0},
            { title: '答案三', field: 'answerThree'},
            { title: '是否正确', field: 'answerThreeResult',type:3,optionList:answerStatus,isNumber:true,data:0},
            { title: '正确回答奖励', field: 'rewardMoney',type:7,precision:2},
            { title: '解析', field: 'parsing',textType:"textarea"},
          ]
      },
        methods: {
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){
              this.$refs.childUpdate.open(row);
            }else if (clickName == "delete"){
                this.$axios.get(`${Url.practice.deleteBatchId}/${row.id}`).then(res => {
                  if (res.code == 0){
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                  }else{
                    this.$message.error(res.message);
                  }
                });
            }
          },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if("新增"==clickName){
                  this.$refs.childUpdate.open();
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(Url.practice.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
              ids:'',
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                /*      { title: '主键', field: 'id',hidden:true},
                      { title: '文章Id', field: 'articleId',hidden:true},
                      { title: '关联问题内容', field: 'questions',textType:"textarea"},
                      { title: '答案一', field: 'answerOne'},
                      { title: '是否正确', field: 'answerOneResult',type:3,optionList:answerStatus,isNumber:true,data:[]},
                      { title: '答案二', field: 'answerTwo'},
                      { title: '是否正确', field: 'answerTwoResult',type:3,optionList:answerStatus,isNumber:true,data:[]},
                      { title: '答案三', field: 'answerThree'},
                      { title: '是否正确', field: 'answerThreeResult',type:3,optionList:answerStatus,isNumber:true,data:[]},
                      { title: '正确回答奖励', field: 'rewardMoney',type:7,precision:2},
                      { title: '解析', field: 'parsing',textType:"textarea"},*/
                    ]
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                      { title: '题目', field: 'questions'},
                        {click:"查询"},
                        {click:"新增"},
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.practice.query+"?articleId="+this.$route.query.articleId,
                    selection: true,
                    sequence: true,
                  method:"get",
                    cols: [
                        { title: '实践问题', field: 'questions'},
                        { title: '最后操作时间', field: 'updateTime'},
                        {title:"操作",btnClick:[
                          {
                            name:"编辑",click:"update",type:"primary",icon: "el-icon-edit"
                          },
                            {
                              name:"删除",click:"delete",type:"primary",icon:"el-icon-delete"
                            }
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
